export default __webpack_public_path__ + "static/hand-3736cf943d4b1b8d04fd18b0358f374b.gif";